import {FilterConf} from '../../../../utils/GlobalSearch/types';
import {CONTENT_TYPE, FILTER_TYPES, TAG_TYPE} from '../../../../utils/GlobalSearch/enums';
import {fetchTags} from '../../../../utils/GlobalSearch/fetchOptions';

const MEET_UP_CONFIG: {[CONTENT_TYPE.MEET_UP]: Record<string, FilterConf>} = {
  'meet-up': {
    topics: {
      key: 'tags',
      label: 'Tags',
      type: FILTER_TYPES.MULTISELECT,
      valueType: TAG_TYPE.TOPICS,
      quick: false,
      fetchOptions: fetchTags,
    },
    goals: {
      key: 'tags',
      label: 'Tags',
      type: FILTER_TYPES.MULTISELECT,
      valueType: TAG_TYPE.GOALS,
      quick: false,
      fetchOptions: fetchTags,
    },
  },
};

export default MEET_UP_CONFIG;
